















import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import AsiCardDetail from "../common/AsiCardDetail.vue";
import Company from "../../models/company/Company";
import {Icon} from "@/helpers/icons";
import {
	createAddressLinesArray,
	createAddressPersonLine,
	createEmailArray,
	createPhoneString
} from "@/helpers/functions_td";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import AddressUpdateDialog from "@/components/AddressUpdateDialog.vue";
import CompanyUpdateDialogContactAddress from "@/components/company/CompanyUpdateDialogContactAddress.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {
		CompanyUpdateDialogContactAddress, AddressUpdateDialog, AsiCardDetailEntry, AsiCardDetail
	}
})
export default class CompanyCardContactAddress extends Vue {

	@Prop({type: Object, default: null})
	public company!: Company | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get personLines(): string[] | null {
		return createAddressPersonLine(this.company?.contactAddress ?? null);
	}

	private get addressLines(): string[] | null {
		return createAddressLinesArray(this.company?.contactAddress ?? null);
	}

	private get emailEntries(): string[] | null {
		return createEmailArray(this.company?.contactAddress.emails ?? null);
	}

	private get phoneString(): string | null {
		return createPhoneString(this.company?.contactAddress.phone ?? null);
	}

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

	@Emit('companyChanged')
	public companyChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
